import { render, staticRenderFns } from "./Foots.vue?vue&type=template&id=1bde1187&scoped=true&"
import script from "./Foots.vue?vue&type=script&lang=js&"
export * from "./Foots.vue?vue&type=script&lang=js&"
import style0 from "./Foots.vue?vue&type=style&index=0&id=1bde1187&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde1187",
  null
  
)

export default component.exports